<div *ngIf="tarea && !caso" class="task-card" (click)="goToCase(tarea.case)">
  <p class="title">
    {{ tarea.task.title }} <span><p class="type-tarea">tarea</p></span>
  </p>
  <div class="divisor"></div>
  <p class="subtitle">{{ tarea.status | status_task }}</p>
</div>

<div *ngIf="caso && !tarea" class="task-card" (click)="goToCase(caso._id)">
  <p class="title">
    {{ caso.caseType.name }} <span><p class="type-caso">caso</p></span>
  </p>
  <div class="divisor"></div>
  <p class="subtitle">Número caso: {{ caso.gai }}</p>
  <p class="subtitle">
    Asignado: {{ caso.assigned ? caso.assigned.fullname : "Sin asignar" }}
  </p>
  <p class="subtitle">Unidad: {{ caso.caseType.unit.name }}</p>
</div>
